"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Constants = require("../Constants");

var _AvatarContentHolder = _interopRequireDefault(require("./baseStyledComponents/AvatarContentHolder"));

var _AvatarWrapper = _interopRequireDefault(require("./baseStyledComponents/AvatarWrapper"));

var _AvatarWrapperOverlay = _interopRequireDefault(require("./baseStyledComponents/AvatarWrapperOverlay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SocialBadge = _interopRequireDefault(require("./baseStyledComponents/SocialBadge"));

var _SVGIcon = _interopRequireDefault(require("./baseStyledComponents/SVGIcon"));

var _SVGIconEdit = _interopRequireDefault(require("./baseStyledComponents/SVGIconEdit"));

var _SVGImage = _interopRequireDefault(require("./baseStyledComponents/SVGImage"));

var _SVGText = _interopRequireDefault(require("./baseStyledComponents/SVGText"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

function delayUntilIdle(callback) {
  var delay = window.requestIdleCallback || window.setTimeout;
  var delayOptions = delay === window.requestIdleCallback ? {
    timeout: 5000
  } : 1000;
  var id = delay(callback, delayOptions);
  return window.requestIdleCallback ? function () {
    return window.cancelIdleCallback(id);
  } : function () {
    return window.clearTimeout(id);
  };
}

var UIAvatarDisplay = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAvatarDisplay, _Component);

  function UIAvatarDisplay(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIAvatarDisplay);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAvatarDisplay).call(this, props));
    _this.state = {
      isDropdownMenuOpen: false,
      isTooltipLoaded: false
    };
    return _this;
  }

  (0, _createClass2.default)(UIAvatarDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.cancelTimeout = delayUntilIdle(function () {
        return _this2.setState({
          isTooltipLoaded: true
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelTimeout();
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState(function () {
        return {
          isDropdownMenuOpen: true
        };
      });
    }
  }, {
    key: "getDefaultAvatar",
    value: function getDefaultAvatar(type) {
      var _options;

      var options = (_options = {}, (0, _defineProperty2.default)(_options, _Constants.AVATAR_TYPES.contact, 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-avatar.png'), (0, _defineProperty2.default)(_options, _Constants.AVATAR_TYPES.company, 'https://static.hsappstatic.net/salesImages/static-1.362/avatars/default-company-avatar.png'), _options);
      return options[type];
    }
  }, {
    key: "MaybeAvatarHover",
    value: function MaybeAvatarHover(_ref) {
      var _isHasTooltip = _ref._isHasTooltip,
          _isHoverlayOpen = _ref._isHoverlayOpen,
          _isListReversed = _ref._isListReversed,
          _ref$_isTooltipLoaded = _ref._isTooltipLoaded,
          _isTooltipLoaded = _ref$_isTooltipLoaded === void 0 ? false : _ref$_isTooltipLoaded,
          className = _ref.className,
          outerChildren = _ref.outerChildren,
          isHoverlay = _ref.isHoverlay,
          size = _ref.size,
          style = _ref.style,
          toolTipName = _ref.toolTipName,
          toolTipPlacement = _ref.toolTipPlacement,
          rest = (0, _objectWithoutProperties2.default)(_ref, ["_isHasTooltip", "_isHoverlayOpen", "_isListReversed", "_isTooltipLoaded", "className", "outerChildren", "isHoverlay", "size", "style", "toolTipName", "toolTipPlacement"]);

      className = className || '';
      className = _isHoverlayOpen ? className + " hover-test" : className;
      var sizeStyle = size && size !== _Constants.AVATAR_SIZES.responsive ? {
        width: size + "px"
      } : {
        width: '100%'
      };
      var calculatedOverlayOffset = {
        overlapOffset: (size || 40) * 0.15
      };
      style = Object.assign({}, style, sizeStyle);
      var AvatarWrapperProps = Object.assign({
        _isListReversed: _isListReversed,
        className: className,
        style: style
      }, calculatedOverlayOffset, rest);

      if (!isHoverlay && !_isHoverlayOpen && _isHasTooltip) {
        return outerChildren && !_isTooltipLoaded ? _react.default.createElement(_AvatarWrapper.default, AvatarWrapperProps) : _react.default.createElement(_UITooltip.default, {
          title: toolTipName,
          placement: toolTipPlacement
        }, _react.default.createElement(_AvatarWrapper.default, AvatarWrapperProps));
      }

      return _react.default.createElement(_AvatarWrapperOverlay.default, AvatarWrapperProps);
    }
  }, {
    key: "tryToGetANameOutOfEmailAddress",
    value: function tryToGetANameOutOfEmailAddress(aString) {
      if (!aString || !aString.indexOf('@')) {
        return aString;
      }

      return aString.split('_').join(' ');
    }
  }, {
    key: "isLatinCharacters",
    value: function isLatinCharacters(aString) {
      var nonLatin = /[^\u0000-\u01BF]/;
      return nonLatin.test(aString);
    }
  }, {
    key: "displayNameToInitials",
    value: function displayNameToInitials(aString, passed) {
      var _this$props = this.props,
          displayName = _this$props.displayName,
          _isHasMore = _this$props._isHasMore,
          _isListReversed = _this$props._isListReversed,
          size = _this$props.size,
          type = _this$props.type;

      if (passed || !aString || typeof aString !== 'string') {
        return _react.default.createElement(_SVGImage.default, {
          size: size,
          _isListReversed: _isListReversed,
          src: this.getDefaultAvatar(_Constants.AVATAR_TYPES[type])
        });
      }

      if (!aString || this.isLatinCharacters(aString) && !passed) {
        return this.displayNameToInitials(this.tryToGetANameOutOfEmailAddress(displayName), true);
      }

      var names = aString.split(' ');
      var initials = names[0].substring(0, 1);

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1);
      }

      return _react.default.createElement(_SVGText.default, {
        wrapperProps: {
          _isHasMore: _isHasMore
        },
        y: "55"
      }, initials);
    }
  }, {
    key: "renderOverlay",
    value: function renderOverlay() {
      var _this3 = this;

      var _this$props2 = this.props,
          isHoverlay = _this$props2.isHoverlay,
          _isHoverlayOpen = _this$props2._isHoverlayOpen,
          size = _this$props2.size;
      var isRenderingOverlay = !!isHoverlay || !!_isHoverlayOpen;
      return isRenderingOverlay && _react.default.createElement(_SVGIconEdit.default, {
        wrapperProps: {
          onMouseEnter: function onMouseEnter() {
            return _this3.handleMouseEnter();
          },
          onClick: function onClick() {},
          size: size
        },
        size: _Constants.AVATAR_SIZES[size]
      });
    }
  }, {
    key: "renderAvatarImageOrText",
    value: function renderAvatarImageOrText() {
      var _this$props3 = this.props,
          src = _this$props3.src,
          displayName = _this$props3.displayName,
          type = _this$props3.type,
          _isHasMore = _this$props3._isHasMore,
          size = _this$props3.size;

      if (src) {
        return _react.default.createElement(_SVGImage.default, {
          size: size,
          src: src
        });
      }

      if (_Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.company) {
        return _react.default.createElement(_SVGImage.default, {
          size: size,
          src: this.getDefaultAvatar(_Constants.AVATAR_TYPES.company)
        });
      }

      if (_isHasMore || _Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.contact || _Constants.AVATAR_TYPES[type] === _Constants.AVATAR_TYPES.company) {
        return this.displayNameToInitials(displayName);
      }

      return _react.default.createElement(_SVGIcon.default, {
        wrapperProps: {
          size: size
        },
        y: 65,
        icon: _Constants.AVATAR_TYPE_ICONS[_Constants.AVATAR_TYPES[type]]
      });
    }
  }, {
    key: "renderSocialBadge",
    value: function renderSocialBadge(socialNetwork) {
      if (!socialNetwork) {
        return undefined;
      }

      return _react.default.createElement(_SocialBadge.default, {
        socialNetwork: socialNetwork
      });
    }
  }, {
    key: "renderContentAndOverlay",
    value: function renderContentAndOverlay() {
      var _this$props4 = this.props,
          href = _this$props4.href,
          _isListReversed = _this$props4._isListReversed,
          size = _this$props4.size,
          type = _this$props4.type;
      return _react.default.createElement(_AvatarContentHolder.default, {
        _isListReversed: _isListReversed,
        size: size,
        href: href,
        type: type
      }, this.renderAvatarImageOrText(), this.renderOverlay());
    }
  }, {
    key: "renderAvatarContent",
    value: function renderAvatarContent(SwitchComponent, props, socialNetwork) {
      return _react.default.createElement(SwitchComponent, props, this.renderContentAndOverlay(), this.renderSocialBadge(socialNetwork));
    }
  }, {
    key: "render",
    value: function render() {
      var MaybeAvatarHover = this.MaybeAvatarHover,
          props = this.props;
      var _isHasTooltip = props._isHasTooltip,
          _isHasMore = props._isHasMore,
          _isHoverlayOpen = props._isHoverlayOpen,
          _isListReversed = props._isListReversed,
          _toolTipOverWrite = props._toolTipOverWrite,
          className = props.className,
          children = props.children,
          displayName = props.displayName,
          isHoverlay = props.isHoverlay,
          onClick = props.onClick,
          size = props.size,
          socialNetwork = props.socialNetwork,
          style = props.style,
          textSpacing = props.textSpacing,
          truncateLength = props.truncateLength,
          toolTipPlacement = props.toolTipPlacement;
      var maybeWrapperProps = {
        _isHasTooltip: _isHasTooltip,
        _isHasMore: _isHasMore,
        _isHoverlayOpen: _isHoverlayOpen,
        _isListReversed: _isListReversed,
        _isTooltipLoaded: this.state.isTooltipLoaded,
        className: className,
        outerChildren: children,
        displayName: displayName,
        isHoverlay: isHoverlay,
        onClick: onClick,
        size: _Constants.AVATAR_SIZES[size],
        style: style,
        toolTipName: _toolTipOverWrite || displayName,
        toolTipPlacement: toolTipPlacement
      };
      var avatarComponent = this.renderAvatarContent(MaybeAvatarHover, maybeWrapperProps, socialNetwork);
      return children ? _react.default.createElement(_UITruncateString.default, {
        onClick: onClick,
        maxWidth: truncateLength
      }, _react.default.createElement("span", {
        className: "align-center"
      }, avatarComponent, _react.default.createElement("span", {
        className: "m-left-" + textSpacing
      }, children))) : avatarComponent;
    }
  }]);
  return UIAvatarDisplay;
}(_react.Component);

UIAvatarDisplay.propTypes = {
  _isHasMore: _propTypes.default.bool,
  _isHasTooltip: _propTypes.default.bool,
  _isHoverlayOpen: _propTypes.default.bool,
  _isListReversed: _propTypes.default.bool,
  _toolTipOverWrite: _propTypes.default.string,
  className: _propTypes.default.string,
  displayName: _propTypes.default.any,
  href: _propTypes.default.string,
  isHoverlay: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  socialNetwork: _propTypes.default.oneOf(Object.keys(_Constants.SOCIAL_MAP)),
  src: _SVGImage.default.propTypes.image,
  type: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_TYPES)),
  textSpacing: _propTypes.default.number,
  truncateLength: _propTypes.default.number,
  toolTipPlacement: _propTypes.default.string
};
UIAvatarDisplay.defaultProps = {
  _isHasMore: false,
  _isHasTooltip: true,
  _isListReversed: false,
  _isHoverLayOpen: false,
  size: 'sm',
  textSpacing: 3,
  truncateLength: 200
};
var _default = UIAvatarDisplay;
exports.default = _default;
module.exports = exports.default;